export default "__VITE_ASSET__D1KtIZOx__"